export default __webpack_public_path__ + "static/media/practiceCalendar.88c4945d.svg";